import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import market_Action from "../../../Redux/marketPlace/action";
import homeActions from "../../../Redux/Home/action";

import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const CommonDiseasesPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { homeContent, teamContent } = useSelector(
    (state) => state.AuthReducer,
  );
  const { currentLanguage } = useSelector((state) => state.commonReducer);

  let [Team, setTeam] = useState([]);

  useEffect(() => {
    dispatch({ type: homeActions.GET_TEAM_CONTENTS });
  }, [currentLanguage]);

  const foundingTeam = teamContent.filter((item) => {
    if (item.type.toLowerCase() === "founders team") {
      let finalLanguage = item?.language?.find(
        (lang) => lang?.language_code === currentLanguage,
      );
      return finalLanguage;
    }
  });

  const coreTeam = teamContent.filter((item) => {
    if (item.type.toLowerCase() === "core team") {
      let finalLanguage = item?.language?.find(
        (lang) => lang?.language_code === currentLanguage,
      );
      return finalLanguage;
    }
  });

  useEffect(() => {
    dispatch({
      type: market_Action.GET_CATEGORY_WISE_LISTINGS_DIARY_CATTLE,
      payload: 1,
    });
  }, [dispatch]);

  useEffect(() => {
    if (homeContent?.length > 0) {
      setTeam(
        homeContent?.filter((val) => {
          if (val?.type === "Team" && val?.img_url && val?.title) {
            return val;
          }
        }),
      );
    }
  }, [homeContent]);

  return (
    <>
      <div
        style={{ paddingTop: "0px" }}
        className="container-fluid farm-equipments-team"
      >
        <Container>
          <div style={{ marginTop: "-160px" }} className="page_heading_div_cls">
            {t("Founding Team")}
          </div>
          <div className="related-products-container">
            {foundingTeam?.map((team, index) => (
              <div key={index} className="related-product-card">
                <a href={team.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={team.img_url}
                    // className="Core-Team-common-disease-img"
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "fit",
                    }}
                    alt={`Product ${index + 1}`}
                  />
                  <div className="core-team-blue-background-2">
                    <div className="unique-team-name">
                      {
                        team?.language?.find(
                          (lang) => lang?.language_code === currentLanguage,
                        ).title
                      }
                    </div>
                    <div className="pink-designation">
                      {
                        team?.language?.find(
                          (lang) => lang?.language_code === currentLanguage,
                        ).contents[0].descirption
                      }
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </Container>
      </div>
      <div>
        <Container>
          <div className="page_heading_div_cls mt-3 mb-3">{t("Core team")}</div>
          <div className="related-products-container">
            {coreTeam?.map((team, index) => (
              <div key={index} className="related-product-card">
                <a href={team.link} target="_blank" rel="noopener noreferrer">
                  <img
                    src={team.img_url}
                    className="Core-Team-common-disease-img"
                    alt={`Product ${index + 1}`}
                  />
                  <div className="core-team-blue-background">
                    <div className="unique-team-name">
                      {
                        team?.language?.find(
                          (lang) => lang?.language_code === currentLanguage,
                        ).title
                      }
                    </div>
                    <div className="pink-designation">
                      {
                        team?.language?.find(
                          (lang) => lang?.language_code === currentLanguage,
                        ).contents[0].descirption
                      }
                    </div>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </Container>
      </div>
    </>
  );
};

export default CommonDiseasesPage;
